/**
 * SidebarRoute
 */
import { Component } from 'react'

import { Route, Switch, withRouter } from 'react-router-dom'
import Sidebar from '../Common/Sidebar'
import DashboardSidePane from '../../components/Dashboard/SidePane'
import GeneralSidePane from './SidePane'

import styles from './Sidebar.css'

const sidebarRoutes = [
  {
    exact: true,
    path: '/',
    component: DashboardSidePane
  },
  {
    path: '/warehouse',
    component: GeneralSidePane
  },
  {
    path: '/item',
    component: GeneralSidePane
  }
]

class SidebarRoute extends Component {
  render () {
    const props = this.props
    // 決定 sidebar 顯示不同 item 的路由
    const currentRoutes = [
      ...sidebarRoutes,
      ...props.routes.map(({ path }) => ({
        exact: true,
        component: DashboardSidePane,
        path
      }))
    ]

    return (
      <Sidebar className={styles.sidebarRoute}>
        <Switch>
          {
            currentRoutes.map((route, index) => {
              const { component: Component } = route
              return (
                <Route
                  key={`route${index}`}
                  {...route}
                  component={({ location }) => (<Component {...props} />)}
                />
              )
            })
          }
        </Switch>
      </Sidebar>
    )
  }
}

/** makes location, history can be accessable in Layout */
const MappedSidebarRoute = withRouter(SidebarRoute)

export default MappedSidebarRoute
